import axios from '../../definitions/axios';
// import redirectUser from '@definitions/redirectUser';
import {
  ServerRequestLogin,
  ServerRequestThirdPartyLogin,
  ServerRequestRegister,
  ServerRequestRecoverPw,
} from '../../interfaces/index';

export const loginUser = ({ params }: { params: ServerRequestLogin }) => {
  return axios.post('/user/user_auth/login/', params);
};
export const loginThirdParty = ({ params }: { params: ServerRequestThirdPartyLogin }) => {
  return axios.post('/user/user_auth/third_party_login/', params);
};

export const getUserInfo = () => {
  return axios.get('/user/user_info/');
};

export const registerUser = ({ params }: { params: ServerRequestRegister }) => {
  return axios.post('/user/user_auth/', params);
};

export const logoutUser = async () => {
  const refreshToken = localStorage.getItem('refresh-token');

  if (refreshToken) {
    await axios.post('/user/user_auth/logout/', { refresh: refreshToken });
  }

  localStorage.removeItem('access-token');
  localStorage.removeItem('refresh-token');
};

export const refreshUser = ({ refreshToken }: { refreshToken: string }) => {
  return axios.post('/user/jwt/token/refresh/', { refresh: refreshToken });
};

export const destoryTokens = () => {
  localStorage.removeItem('access-token');
  localStorage.removeItem('refresh-token');
//   return redirectUser('/');
};

export const forgotPassword = ({ params }: { params: ServerRequestRecoverPw }) => {
  return axios.post('/user/user_password_management/recover_password/', params);
};

export const confirmPassword = async ({ params }: { params: ServerRequestRecoverPw }) => {
  await axios.post('/user/user_password_management/reset_password/', params);
//   return redirectUser('/');
};

export const checkMail = async (params: { email: string }) => {
  try {
    const regex =
      /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;

    if (params.email.match(regex)) {
      const response = await axios.post('/user/email_management/email_availability/', params);

      const { detail, code } = response.data;
      return { detail, code };
    }

    const status = 'ok';
    const detail = `email: ${params.email} is not valid`;

    return { status, detail };
  } catch (err) {
    console.log(err);
    return err;
  }
};


